import { AboutRow } from './aboutRow';

export class About {
  whoWeAre?: string;
  whoWeAreHeader?: string;
  whyUs?: string;
  whyUsHeader?: string;
  bannerImageUrl?: string;
  html?: string;
  aboutUsSliderUrls: string[] = [];
  rows: AboutRow[] = [];

  constructor() {
    // this.bannerImageUrl = 'https://firebasestorage.googleapis.com/v0/b/prod-rocky-hill-storage.appspot.com/o/frame-100180.jpg?alt=media&token=aef8866f-a7fb-4f23-8fe7-921c7bb5aac7';
    // this.whoWeAre =
    //   `Rocky Hill Storage is a locally owned and managed self storage facility focused on customer service. Our self storage facility is designed to offer affordable, easily accessible storage space for residential and commercial customers. \n\n` +
    //   `Rocky Hill Storage seeks to be a desirable, safe and customer oriented facility perfectly suited for maintaining and accessing valued personal and business belongings. We feature an affordable, convenient and secure facility operated by a professional staff who care about your belongings as much as you do.`;
    // this.whyUs = `Because your satisfaction is our number # 1 goal. We realize that your selection of a storage facility is important. Our friendly professional staff ensures top quality customer care as each and every customer is our first and foremost priority. Our passion for cleanliness and security is everywhere you look and our customer focus is matched by our competitive pricing. \n\n` +
    //   `We are confident that you will agree that Rocky Hill Storage will exceed your expectations.`;
  }
}



// WEBPACK FOOTER //
// ./src/ng2/app/models/about.ts